import React, { useEffect, useState, useCallback } from 'react';

import ReactGA from 'react-ga';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import {
  createStyles,
  jssPreset,
  makeStyles,
  StylesProvider,
  ThemeProvider
} from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import Auth from 'src/components/Auth';
import CookiesNotification from 'src/components/CookiesNotification';
//import SettingsNotification from 'src/components/SettingsNotification';
//import GoogleAnalytics from 'src/components/GoogleAnalytics';
import ScrollReset from 'src/components/ScrollReset';
import useSettings from 'src/hooks/useSettings';
import { createTheme, ThemeConfigurator } from 'src/theme';
import Routes from 'src/Routes';
//import RoutesDev from 'src/RoutesDev';

import withClearCache from './ClearCache';
import { useDispatch, useSelector } from 'react-redux';
import { themeRegister } from './actions/themeActions';
import axios from 'axios';
import { themeConfig } from './theme/constans';
import { VERSION_APP, VERSION_CACHE, VERSION_CODE } from './constants';
import SplashScreen from './components/SplashScreen';
import { handleGetStorage } from './hooks/validationParticipantes';
import { handdleGetStorage, handdleSetStorage } from './hooks/useSocioValidacion';
import getOS from './hooks/getOS';
import LoadingScreen from './components/LoadingScreen';
import { atob } from 'buffer';


const history = createBrowserHistory();
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

// Initialize google analytics page view tracking
ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID); // Aqui pones tu identificador de cuenta de Google Analytics

history.listen(location => {
  ReactGA.set({ page: location.pathname }); // Update the user's current page
  ReactGA.pageview(location.pathname); // Record a pageview for the given page
});

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0
      },
      html: {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        height: '100%',
        width: '100%'
      },
      body: {
        height: '100%',
        width: '100%'
      },
      '#root': {
        height: '100%',
        width: '100%'
      }
    }
  })
);

// const ClearCacheComponent = withClearCache();

const refreshCacheAndReload = async () => {
  try {
    // Se guardan las dos versiones en variables diferentes
    const currentVersion = localStorage.getItem('versionCache');
    const newVersion = VERSION_CACHE.appVersion;
    
    console.log("Verificando versión de cache:", { currentVersion, newVersion });
    
    // Si las versiones coinciden, no hacer nada
    if (currentVersion === newVersion && currentVersion !== null) {
      console.log("Cache actualizado, no se requiere limpieza");
      return;
    }

    console.log("Iniciando limpieza de cache...");
    
    // 1. Guardar nueva versión ANTES del reload para evitar loops infinitos
    localStorage.setItem("versionCache", newVersion);
    
    // 2. Limpiar Service Worker caches (solo si está disponible)
    if ('caches' in window) {
      try {
        const cacheNames = await caches.keys();
        console.log("Eliminando caches:", cacheNames);
        
        await Promise.all(
          cacheNames.map(cacheName => caches.delete(cacheName))
        );
        console.log("Service Worker caches eliminados");
      } catch (cacheError) {
        console.warn("Error al eliminar Service Worker caches:", cacheError);
      }
    }
    
    // 3. Limpiar cache del navegador y recargar
    console.log("Recargando aplicación sin cache");
    
    // Método moderno para recargar sin cache
    if ('serviceWorker' in navigator) {
      // Desregistrar service workers activos
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => registration.unregister());
      });
    }
    
    // Forzar recarga completa
    window.location.href = window.location.href;
    
  } catch (error) {
    console.error("Error durante limpieza de cache:", error);
    
    // Fallback: recarga simple si todo falla
    try {
      localStorage.setItem("versionCache", VERSION_CACHE.appVersion);
      window.location.href = window.location.href;
    } catch (fallbackError) {
      console.error("Error en fallback:", fallbackError);
    }
  }
};
 /**
   * Funcion para obtener el Id del dispositivo.
   * 
   * Ayuda a setear el Id del dispositivo en el localStorage para las peticiones e identificacion del usuario con su dispositivo seguro.
   * 
   * Obs: Se valida si el dispositivo es Android o IOS para agregar el evento de escucha del mensaje.
   * 
   * Obs: Se agrega el evento de escucha del mensaje para obtener el Id del dispositivo.
   * 
   * Obs: Se envia el mensaje al WebView para obtener el Id del dispositivo.
   * 
   * Obs: Se guarda el Id del dispositivo en el localStorage.
   * 
   * Obs: Si el dispositivo es un navegador web se utiliza la funcion de userAgent para obtener el Id del dispositivo.
   */
 
 



function MainApp() {
  useStyles();
  const dispatch = useDispatch();
  const [themeConfigRemote, setThemeConfigRemote] = useState(null);
  const { settings } = useSettings();
  const notistackRef = React.createRef();

  const handleMessage = useCallback((event) => {
    try {
      const data = JSON.parse(event.data);

       console.log("handleMessage", data);
      if (data) {
        
        localStorage.setItem('deviceId', JSON.stringify({
          codigo: window.btoa(data?.codigo || `APP_${themeConfigRemote?.afinidad}`),
          imei: window.btoa(data?.imei || `${data?.deviceId}` || `APP_${themeConfigRemote?.afinidad}`),
          modelo: window.btoa(data?.modelo || `APP_${themeConfigRemote?.afinidad}`),
          os: window.btoa(data?.os || `APP_${themeConfigRemote?.afinidad}`),
          osVersion: window.btoa(data?.osVersion || `APP_${themeConfigRemote?.afinidad}`)
        }));
        getOS() === 'Android' ? document.removeEventListener("message", handleMessage) : window.removeEventListener("message", handleMessage);
      }

    } catch (error) {
      console.error('Error en handleMessage:', error);
      getOS() === 'Android' ? document.removeEventListener("message", handleMessage) : window.removeEventListener("message", handleMessage);
    }
  }, [themeConfigRemote])

    const handleGetDeviceId = useCallback(() => {

    try {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'getDeviceId', data: null }));
      }else {
            localStorage.setItem('deviceId', JSON.stringify({
            codigo: window.btoa("WEB"),
            imei: window.btoa(navigator.userAgent.toString()),
            modelo: window.btoa("WEB"),
            os: window.btoa("WEB"),
            osVersion: window.btoa("WEB")
          }));
      }
    } catch (error) {
      console.error('Error en getDeviceId:', error);
    }

    if (window.ReactNativeWebView) {
      getOS() === 'Android' ? document.addEventListener("message", handleMessage) : window.addEventListener("message", handleMessage);
    }
  }, [handleMessage]);

  const handleVersionApp = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'versionApp', data: VERSION_APP, versionWeb: VERSION_CODE }));
    }
  }

  useEffect(() => {
    async function fetchThemeConfig() {
      try {
        const themeConfig = await handleGetStorage();

        if (!themeConfig || themeConfig.error) { //  Si `themeConfig` falla, seteamos error
          throw new Error("No se pudo cargar la configuración.");
        }

        setThemeConfigRemote(themeConfig);
        handleGetDeviceId();
        handleVersionApp();
        refreshCacheAndReload();
      } catch (error) {
        console.log("Error al obtener el themeConfig", error);
        setThemeConfigRemote("error"); //  Guardamos "error" para mostrar pantalla de error
      }
    }

    fetchThemeConfig();
}, []);

  
return (
  themeConfigRemote === null ? <SplashScreen /> :
  themeConfigRemote === "error" ? (
    <div style={{
      textAlign: 'center',
      color: '#333',
      fontSize: '18px',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '20px',
      position: 'relative'
    }}>
      {/* Logo Dimo en la esquina superior izquierda */}
      <div style={{
        position: 'absolute',
        top: '20px',
        left: '20px'
      }}>
        <img src="https://dimo.com.py/images/dimo-logo-una-iniciativa-de-cabal-paraguay.svg" 
             alt="Dimo Cabal"
             style={{ width: '180px' }} />
      </div>

      {/* Imagen de error */}
      <img src="https://i.ibb.co/bjW5XgFh/Untitled-design.png" 
           alt="Oops!"
           style={{ width: '200px' }} />

      <h2 style={{ fontWeight: 'bold' }}>
        Lo sentimos, aún no está listo 
        <span style={{ display: 'block' }}>Vuelve más tarde!</span>
      </h2>
      {/* Botón de Inicio */}
      <a href="https://dimo.com.py/home" 
         style={{
           textDecoration: 'none',
           backgroundColor: '#8798FF',
           padding: '12px 30px',
           borderRadius: '8px',
           color: 'white',
           fontSize: '16px',
           fontWeight: 'bold'
         }}>
         Inicio
      </a>

      {/* Link de contacto */}
      <a href="https://dimo.com.py/home#contacto" 
         style={{ textDecoration: 'underline', color: '#666', fontSize: '14px' }}>
        Contactar soporte
      </a>
    </div>
  ) :
  
  <ThemeProvider theme={createTheme({settings,themeConfigRemote})}>
    <StylesProvider jss={jss}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <SnackbarProvider
          ref={notistackRef}
          maxSnack={4}
          onClose={(event, reason) => {
            if (reason === 'clickaway') {
              notistackRef.current.closeSnackbar();
            }
          }}
          autoHideDuration={20000}
        >
          <Router history={history}>
            <Auth>
              <ScrollReset />
              {/*<GoogleAnalytics />*/}
              <CookiesNotification />
              {/*<SettingsNotification />*/}
              <Routes />
            </Auth>
          </Router>
        </SnackbarProvider>
      </MuiPickersUtilsProvider>
    </StylesProvider>
  </ThemeProvider>
);

}

function App() {
  return <MainApp/>;
}

export default App;
